import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import DataTable from "../../common/components/DataTable";
import { SettingsDisplay } from "../../common/components/SettingsPanels";
import useCredentials from "../../common/hooks/credentialsHook";
import useNetwork from "../../common/hooks/networkHook";
import { dynamicSort } from "../../common/utils/tableUtilities";
import { canCreateGlossary, canRemoveGlossary, canUpdateGlossary, createGlossaryTerm, removeGlossaryTerm, updateGlossaryTerm, useGlossaryImpl } from "../../reducers/glossarySlice";
import PropTypes from 'prop-types';

const defaultSort = ['term']

const Glossary = ({ uuid, label, onClose }) => {
    const { t } = useTranslation();
    const credentials = useCredentials();
    const network = useNetwork();
    const glossary = useGlossaryImpl();

    const tableData = useMemo(() => {
        let entries = Object.values(glossary).flat();
        entries.sort(dynamicSort(['term']));
        return entries;
    }, [glossary]);

    const tableDef = useMemo(() => [
        { type: "text", editable: true, field: "term", title: t('glossaryTerm') },
        { type: "text", editable: true, field: "definition", title: t('glossaryDefinition')}
    ], [t]);

    const canCreate = canCreateGlossary(credentials);
    const canUpdate = canUpdateGlossary(credentials);
    const canRemove = canRemoveGlossary(credentials);

    return <SettingsDisplay uuid={uuid} title={label} onClose={onClose}>
        <DataTable value={tableData} columns={tableDef} defaultSort={defaultSort} disabled={!canUpdate} disableAdd={!canCreate} disableRemove={!canRemove} confirmDelete={true}
            csvFilename={t('glossary') + '.csv'}
            showFilter={true}
            onAdd={term => createGlossaryTerm(network, term)} onUpdate={(term, field, value) => updateGlossaryTerm(network, { id: term.id, [field]: value })}
            onRemove={term => removeGlossaryTerm(network, term)}>
        </DataTable>
    </SettingsDisplay>
}

Glossary.propTypes = {
    /**
     * ID to identify the settings status entry
     */
    uuid: PropTypes.string.isRequired,
    /**
     * Label for the screen
     */
    label: PropTypes.string.isRequired,
    /**
     * Function to call when the screen is closed
     */
    onClose: PropTypes.func
}

export default Glossary;